import Script from 'next/script';
import type { FunctionComponent } from 'react';

import { getAppSetting } from '@/domains/core/settings/appSettings';

import { useKlarna } from '../Payment/components/PaymentMethods/Klarna/useKlarna';

interface KlarnaScriptProps {
  forceShowKlarna?: boolean;
}

export const KlarnaScript: FunctionComponent<KlarnaScriptProps> = ({
  forceShowKlarna = false,
}) => {
  const klarnaClientId = getAppSetting('KLARNA_API_PUBLIC_KEY');
  const src = 'https://js.klarna.com/web-sdk/v1/klarna.js';
  const { showKlarna } = useKlarna();

  if (!showKlarna && !forceShowKlarna) {
    return null;
  }

  return (
    <Script
      async
      id="klarna-id"
      src={src}
      data-client-id={klarnaClientId}
      strategy="lazyOnload"
    />
  );
};
